import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, FormControl, Select as MaterialSelect  ,Box ,TextField,
  FormControlLabel, LinearProgress, Checkbox, Typography,
RadioGroup, Radio, FormLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NvoEditDomicilio = ({modalAbierto,setModalAbierto,titulo,regis,funcionActuliza, Proveedor}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [registro, setRegistro]= useState({Orden:0, Direccion:"", Alias:"", Descr:"", Municipio:"",Estado:"",Responsable:"",
          Email:"", Banco:"", Clabe:"", Contacto:""});  
  const {Orden,  Alias, Descr, Municipio,  Email, Contacto, Clabe, Banco  }=registro    
  
  const [listEstado, setListEstado] = useState([])  
  const [listBanco, setListBanco] = useState([])    
  
  React.useEffect(()=>{     
    //console.log(regis);
    if (regis.length !== 0) {
      setRegistro({...registro,  Banco:regis.BanId,       
      Clabe:regis.Clabe, Contacto:regis.Contacto, Alias:regis.Alias, Orden:regis.Id,
      Email:regis.Email, })           
    }
         
    getListBanco()          
    return ()=> {
      source.cancel();
    }     
      // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

const getListBanco = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/renta/banco";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListBanco(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };  
 
  const registrarNActividad=()=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,                              
      Alias: Alias,
      Status:1,            
      Proveedor:Proveedor.Id,
      Banco:Banco,
      Clabe:Clabe,
      Email:Email,
      Contacto:Contacto,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/renta/proveedor/cuenta/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje= regis.length!==0 ?
        `Se edito correctamente el registro "${Descr} " `        
        :`Se Registro correctamente la nueva Cuenta `
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza()
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const mostrarAlertas =(auxMensaje)=>{ 
    setTipoAdvertencia("warning")
    let mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  } 

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
  
  function validaVariable(auxCampo,auxMensaje,auxTamanio) 
  { let respuesta=false
    if ( valNulos(auxMensaje,auxCampo) ) 
    { if (auxCampo.length>=auxTamanio ) 
      {                
        respuesta=true                    
      }else
      {            
        mostrarAlertas(`${auxMensaje}`) 
      }
    }        
    return respuesta;
  }

  function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }

  const guardTerminal = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeEdo = e =>
  {      
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeNumTel = e =>
	{ let expNopermitida= new RegExp('[A-Za-z$@#_&-+()/:;!?,<>=]');          
    let expMenos = new RegExp("'");
    let expMas = new RegExp('-+');     
    let expCadena = new RegExp('[.0-9$]');             
    if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
      && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
      || e.target.value===' '|| e.target.value==='') 
    {
      setRegistro({ ...registro,[e.target.name] : e.target.value })                   
    }		    
	}; 

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }

  const guardarDatos = () => 
  {
    if (validaDatos(Banco,"Seleccionar Banco") && validaVariable(Clabe, "Llenar campo de Clabe (18 caracteres)",18) && 
      validaVariable(Alias, "Llenar campo de Alias (mayor o igual 5 caracteres)",5) &&
      validaVariable(Contacto, "Llenar campo de Teléfono (10 caracteres)",10) && 
      validaVariable(Email, "Llenar campo de Email (mayor o igual a 5 caracteres)",5)) 
    {
    
      registrarNActividad()                                                                                        
    }                            
  };

  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };


  
  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"md"} btnDesact={btnDesact}
  >
  <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:30+'rem'}} >       
    <Box display={"flex"} flexDirection={"column"}>
    <Box display={"flex"} flexDirection={"row"} mb={2}>
    {/* listEstado.length!==0 ?  
      <Box display="flex" flexDirection="row" mr={2}>        
        <FormControl className={classes.formControl} size="small" style={{width:12+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Estado</InputLabel>
          <MaterialSelect
            native value={Estado}  onChange={onChangeEdo}
            inputProps={{ name: 'Estado', id: 'Estado', }}            
          >
            <option aria-label="None" value="" />      
            {listEstado.map((row) => (
                <option value={row.Id}>{row.Nom}</option>
            ))}   
          </MaterialSelect>
        </FormControl>             
      </Box> 
      :<LinearProgress color="primary" /> */}    
      {listBanco.length!==0 ?  
       <Box display="flex" flexDirection="row">        
        <FormControl className={classes.formControl} size="small" style={{width:14+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Banco</InputLabel>
          <MaterialSelect
            native value={Banco}  onChange={guardTerminal}
            inputProps={{ name: 'Banco', id: 'Banco', }}            
          >
            <option aria-label="None" value="" />      
            {listBanco.map((row) => (
                row.Id !==0 &&<option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>             
      </Box> 
      :null}   
    </Box>
    <Box style={{width:30+'rem'}}>      
      <FormControl component="fieldset" style={{width:28+'rem'}}>    
        <TextField id="outlinedClabe" variant='outlined'           
          label="Clabe"  size="small"
          value={Clabe} onChange={onChangeRef}  
          name="Clabe" fullWidth inputProps= {{ maxlength: 18 }}
        /> 
      </FormControl>
      </Box>     
      <Box style={{width:30+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:28+'rem'}}>    
        <TextField id="outlinedAlias" variant='outlined'           
          label="Alias"  size="small"
          value={Alias} onChange={onChangeRef}  
          name="Alias" fullWidth
        /> 
      </FormControl>
      </Box>     
      <Box display="flex" style={{width:30+'rem'}}>
        <Box style={{width:9+'rem'}} mt={2} mr={1}>      
        <FormControl component="fieldset" style={{width:9+'rem'}}>    
          <TextField  id="CInt-input" onChange={onChangeNumTel} style={{width:9+'rem'}}
            label="Teléfono" defaultValue="Contacto" value={Contacto} name='Contacto' size="small" //type="number"
            inputProps= {{ maxlength: 10 }} autoComplete='off' variant='outlined'   
          /> 
        </FormControl>      
        </Box>  
        <Box  mt={2}>      
        <FormControl component="fieldset" style={{width:'18.5rem'}}>    
          <TextField id="outlinedEmail" variant='outlined'           
            label="Email"  size="small"
            value={Email} onChange={onChangeRef}  
            name="Email" fullWidth
          /> 
        </FormControl>      
        </Box>  
      </Box>
    </Box>                        
    </form>      
  </Modal>
  );
}
 
export default NvoEditDomicilio;